<script>
import { mapGetters } from 'vuex'
import { notify } from '@/utils/helpers/Notify'
// import store from '@/store/store'
import { signatureMixins } from '@/Mixins/Signatures'
import SignaturePad from '@/components/SignaturePad.vue'
import SignatureResource from '@/resources/SignatureResource'
import BaseResource from '@sigmacloud/sigma-client/dist/resources'

export default {
  components: {
    SignaturePad
  },

  mixins: [
    signatureMixins
  ],

  data () {
    return {
      currentPassword: undefined,
      newPassword: undefined,
      confirmPassword: undefined,
      esaAcknowledged: false,
      eSigEnabled: false,
      base: new BaseResource(),
      signature: new SignatureResource({
        name: undefined,
        image_type: 'PNG',
        base64_blob: undefined,
        user: undefined,
        ip: undefined
      })
    }
  },

  computed: {
    // This generates the full base64 string needed by signaturePad
    convertedSignature () {
      if (!this.signature) return undefined
      const type = this.signature.attributes.image_type || 'PNG'
      if (!this.signature.attributes.base64_blob) return ''
      else return 'data:image/' + type.toLowerCase() + ';base64,' + this.signature.attributes.base64_blob
    },

    resources () {
      return {
        SignatureResource
      }
    },

    ...mapGetters({
      getUser: 'getUser',
      activeInstance: 'getActiveInstance'
    })
  },

  methods: {
    /**
     * Handles transaction selection
     * @param selection
     */
    showError (message) {
      notify(this, 'error', message || 'Please complete all relevant fields')
    },

    clearPassword () {
      this.currentPassword = this.newPassword = this.confirmPassword = undefined
    },

    updatePassword (event) {
      this.checkAuth()
      notify(this, 'success', 'Coming Soon!')
      console.log('Disable the form until backend is fixed.')
    },

    // No need to re-up the token
    async checkAuth (request = { username: this.getUser.username, password: this.currentPassword }) {
      try {
        const response = await this.$store.dispatch('reauthenticate', { request, url: this.activeInstance.url })
        if (response && response.status === 200) {
          return true
        } else {
          return false
        }
      } catch (apiError) {
        return false
      }
    },

    async loadSignature () {
      const search = await this.resources.SignatureResource.filter({ user: this.getUser.userId })

      if (search && search.resources && search.resources.length) {
        this.signature = search.resources[search.resources.length - 1]
        this.esaAcknowledged = true
        return true
      } else {
        return false
      }
    },

    async updateSignature (sigRaw) {
      if (!sigRaw) return false

      const sigParts = sigRaw.split(',')
      if (!sigParts || !Array.isArray(sigParts) || sigParts.length !== 2) {
        return false
      }

      this.signature.attributes.image_type = 'PNG'
      this.signature.attributes.name = this.getUser.username
      this.signature.attributes.user = this.getUser.userId
      // this.signature.attributes.name = 'jmunowitch'
      // this.signature.attributes.user = 16
      this.signature.attributes.base64_blob = sigParts[1]

      const { response } = await this.signature.save()
      if (response && (response.status === 201 || response.status === 200)) {
        notify(this, 'success', 'Signature saved successfully!')
      } else {
        notify(this, 'error', 'Signature saving failed.  Please call support')
      }
    },

    log (event) {
      console.log(event)
    }
  },

  async created () {
    await this.$store.dispatch('fetchUiSetting', { name: 'ESIG_ENABLED' })
  },

  mounted () {
    this.eSigEnabled = true // this.$store.getters.getUiSettings['ESIG_ENABLED'] || false
    // console.log('Signature Enabled: ' + this.eSigEnabled)
    if (this.eSigEnabled) {
      this.loadSignature()
    }
  }
}
</script>

<template>
  <el-col :span="24" id="signature_capture" element-loading-text="Fetching page...">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" class="title">MY PROFILE</el-row>
      </el-col>
    </el-row>
    <!-- Start of password section -->
    <div hidden>
    <el-row align="middle" justify="start" class="m-left-20 section subtitle">CHANGE PASSWORD</el-row>
    <el-row align="middle" justify="start">
      <el-row class="padding-20" type="flex" align="middle" justify="start">
        <el-col :span="1"></el-col>
        <el-col :span="19">
          Passwords should be long (at least 20 characters) and tough to guess but easy to remember.  For instance,<br />&ldquo;<span class="code">Grandmother really loved Apples!</span>&rdquo; is much tougher to crack, better to type, and easier to recall than &ldquo;<span class="code">!ZrV#fj8@B</span>&rdquo;.
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="1"></el-col>
        <el-col :span="3">
          <el-row type="flex" align="middle" justify="start">Current Password:</el-row>
        </el-col>
        <el-col :span="6">
          <input class="password el-input__inner"
            v-model="currentPassword"
            :name="'current_password' + Math.floor(Math.random() * 1000000 + 1)"
            :autocomplete="'force_off_' + Math.floor(Math.random() * 1000000 + 1)"
            :required="newPassword"
          />
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="1"></el-col>
        <el-col :span="3">
          <el-row type="flex" align="middle" justify="start">New Password:</el-row>
        </el-col>
        <el-col :span="6">
          <input class="password el-input__inner"
            v-model="newPassword"
            :name="'new_password' + Math.floor(Math.random() * 1000000 + 1)"
            :autocomplete="'force_off_' + Math.floor(Math.random() * 1000000 + 1)"
            :required="currentPassword"
          />
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="1"></el-col>
        <el-col :span="3">
          <el-row type="flex" align="middle" justify="start">Confirm Password:</el-row>
        </el-col>
        <el-col :span="6">
          <input class="password el-input__inner"
            v-model="confirmPassword"
            :name="'confirm_password' + Math.floor(Math.random() * 1000000 + 1)"
            :autocomplete="'force_off_' + Math.floor(Math.random() * 1000000 + 1)"
            :required="newPassword"
          />
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="p-top-5">
        <el-col :span="4"></el-col>
        <el-col :span="16">
          <el-button type="danger" class="bold" @click="clearPassword">Reset</el-button>
          <el-button type="success" class="bold" @click="updatePassword">Update</el-button>
        </el-col>
      </el-row>
    </el-row>
    </div>
    <!-- End of password section -->
    <div v-show="eSigEnabled">
      <el-row type="flex" align="middle" justify="start" class="m-left-20 section subtitle">UPDATE ELECTRONIC SIGNATURE</el-row>
      <el-row class="headerRow" type="flex" justify="start" align="top">
        <el-col :span="1"></el-col>
        <el-col :span="23">
          <el-row justify="start">
            Your signature may be used to electronically sign checks and other payment methods. Please read and accept the terms:
            <ol>
              <li>I certify that I am the logged in user and have legal authority to review, approve, and/or sign such payments,</li>
              <li>I should <strong>never</strong> give my username or password to anyone else,</li>
              <li>I understand that payment approvals will be logged,</li>
              <li>I have read the <a href="https://www.revolutiones.com/about/communication" target="_blank" >Electronic Signature Agreement</a> policy.</li>
            </ol>
            <div class="padding-0-20">
              <input v-model="esaAcknowledged" type="checkbox" />
              <span class="bold">I have read and agree to the terms above.</span>
            </div>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="esaAcknowledged" class="headerRow" type="flex" justify="start" align="top" id="signature_capture-body" >
        <el-col :span="2"></el-col>
        <el-col :span="15">
          <el-row type="flex" justify="start">
            <signature-pad signature-for="user" :sig="convertedSignature" @onSigned="updateSignature" @onError="showError" @onChange="log" :key="signature ? signature.id : 0" />
          </el-row>
        </el-col>
      </el-row>
    </div>
  </el-col>
</template>

<style scoped>
  .title { font-size: 1.5em; }
  .subtitle { font-size: 1.2em; font-style: italic;}
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 50px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  a { color: blue; text-decoration: underline; }
  .padding-20 { padding: 20px 20px 20px 20px; }
  .padding-0-20 { padding: 0px 0px 20px 20px; }
  .m-left-20 { margin-left: 20px; }
  .m-top-20 { margin-top: 20px; }
  .p-top-5 { padding-top: 5px; }
  .bold { font-weight: 700; }
  .code { font-family: 'Lucida Console', Monaco, monospace; font-weight: 700; }
  /* element-plus .el-input__inner is borderless (border moved to the wrapper); restore the input box look. */
  .password {
    -webkit-text-security: disc;
    box-sizing: border-box;
    width: 100%;
    height: var(--el-component-size, 32px);
    padding: 1px 11px;
    font-size: var(--el-font-size-base, 14px);
    color: var(--el-input-text-color, var(--el-text-color-regular, #606266));
    background-color: var(--el-fill-color-blank, #fff);
    border: 1px solid var(--el-border-color, #dcdfe6);
    border-radius: var(--el-border-radius-base, 4px);
    outline: none;
  }
  .password:hover { border-color: var(--el-border-color-hover, #c0c4cc); }
  .password:focus { border-color: var(--el-color-primary, #409eff); }
</style>
